
    <template>
      <section class="relax-doc">
        <h1>Modal 对话框</h1>
<blockquote>
<p>模态对话框</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>使用 <code>v-model</code> 控制打开关闭</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; @click=&quot;visible = true&quot;&gt;显示对话框&lt;/x-button&gt;
  &lt;x-modal 
    title=&quot;戏命师&quot;
    v-model=&quot;visible&quot; 
    @ok=&quot;ok&quot;
    @cancel=&quot;cancel&quot;
  &gt;
    &lt;p&gt;我于杀戮之中绽放 ,亦如黎明中的花朵&lt;/p&gt;
    &lt;p&gt;你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。&lt;/p&gt;
  &lt;/x-modal&gt;
&lt;/template&gt;

&lt;script&gt;
  import {ref, getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const visible = ref(false)

      const ok = () =&gt; {
        $message.success('点击了确定')
      }

      const cancel = () =&gt; {
        $message('点击了取消')
      }
 
      return {
        visible,
        ok,
        cancel
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="zi-ding-yi-yang-shi"><a class="header-anchor" href="#zi-ding-yi-yang-shi"></a> 自定义样式</h2>
<blockquote>
<p>通过 <code>slot</code> 自定义样式</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; plain @click=&quot;visible1 = true&quot;&gt;自定义页头页脚&lt;/x-button&gt;
  &lt;x-modal v-model=&quot;visible1&quot; style=&quot;width: 300px&quot;&gt;
    &lt;template #head&gt;
      &lt;div style=&quot;text-align: center&quot;&gt;
        这个组件
        &lt;x-icon type=&quot;x-icon-thumbs-up&quot; /&gt;
      &lt;/div&gt;
    &lt;/template&gt;
    &lt;p&gt;我于杀戮之中绽放 ,亦如黎明中的花朵&lt;/p&gt;
    &lt;p&gt;你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。&lt;/p&gt;
    &lt;template #footer&gt;
      &lt;x-button type=&quot;warning&quot; block @click=&quot;visible1 = false&quot;&gt;确定&lt;/x-button&gt;
    &lt;/template&gt;
  &lt;/x-modal&gt;

  &lt;x-button type=&quot;primary&quot; plain @click=&quot;visible2 = true&quot;&gt;不带标题&lt;/x-button&gt;
  &lt;x-modal v-model=&quot;visible2&quot;&gt;
    &lt;p&gt;吾虽浪迹天涯，却未迷失本心&lt;/p&gt;
    &lt;p&gt;吾之初心，永世不忘&lt;/p&gt;
    &lt;p&gt;正义，好个冠冕堂皇之词&lt;/p&gt;
  &lt;/x-modal&gt;
&lt;/template&gt;

&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const visible1 = ref(false)
      const visible2 = ref(false)

      return {
        visible1,
        visible2,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="yi-bu-guan-bi"><a class="header-anchor" href="#yi-bu-guan-bi"></a> 异步关闭</h2>
<blockquote>
<p>给 <code>Modal</code> 添加属性 <code>loading</code> 后，点击确定后异步关闭对话框。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; plain @click=&quot;visible = true&quot;&gt;显示对话框&lt;/x-button&gt;
  &lt;x-modal 
    title=&quot;戏命师&quot;
    v-model=&quot;visible&quot;
    :loading=&quot;loading&quot;
    @ok=&quot;ok&quot;
  &gt;
    &lt;p&gt;我于杀戮之中绽放 ,亦如黎明中的花朵&lt;/p&gt;
    &lt;p&gt;你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。&lt;/p&gt;
  &lt;/x-modal&gt;
&lt;/template&gt;

&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const visible = ref(false)
      const loading = ref(false)

      const ok = () =&gt; {
        loading.value = true
        setTimeout(() =&gt; {
          loading.value = false
        }, 2000)
      }

      return {
        visible,
        loading,
        ok,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jin-yong-guan-bi"><a class="header-anchor" href="#jin-yong-guan-bi"></a> 禁用关闭</h2>
<blockquote>
<p>可以禁用关闭和遮罩层关闭。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; @click=&quot;visible1 = true&quot;&gt;禁用右上角关闭 （含Esc键）&lt;/x-button&gt;
  &lt;x-modal 
    title=&quot;戏命师&quot;
    :closable=&quot;false&quot;
    v-model=&quot;visible1&quot; 
  &gt;
    &lt;p&gt;我于杀戮之中绽放 ,亦如黎明中的花朵&lt;/p&gt;
    &lt;p&gt;你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。&lt;/p&gt;
  &lt;/x-modal&gt;

  &lt;x-button type=&quot;primary&quot; @click=&quot;visible2 = true&quot;&gt;禁用遮罩层关闭&lt;/x-button&gt;
  &lt;x-modal 
    title=&quot;戏命师&quot;
    :mask-closable=&quot;false&quot;
    v-model=&quot;visible2&quot; 
  &gt;
    &lt;p&gt;我于杀戮之中绽放 ,亦如黎明中的花朵&lt;/p&gt;
    &lt;p&gt;你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。&lt;/p&gt;
  &lt;/x-modal&gt;
&lt;/template&gt;

&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const visible1 = ref(false)
      const visible2 = ref(false)

      return {
        visible1,
        visible2,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="shi-li-hua-fang-fa"><a class="header-anchor" href="#shi-li-hua-fang-fa"></a> 实例化方法</h2>
<blockquote>
<p>不同的状态：信息、成功、警告、错误</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo4 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;info&quot; plain @click=&quot;open('info')&quot;&gt;显示信息对话框&lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; plain @click=&quot;open('error')&quot;&gt;显示错误对话框&lt;/x-button&gt;
  &lt;x-button type=&quot;success&quot; plain @click=&quot;open('success')&quot;&gt;显示成功对话框&lt;/x-button&gt;
  &lt;x-button type=&quot;warning&quot; plain @click=&quot;open('warning')&quot;&gt;显示警告对话框&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$modal} = instance.appContext.config.globalProperties

      const open = (type) =&gt; {
        $modal[type]({
          title: '戏命师',
          content: '你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。'
        })
      }

      return {
        open
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="que-ren-dui-hua-kuang"><a class="header-anchor" href="#que-ren-dui-hua-kuang"></a> 确认对话框</h2>
<blockquote>
<p>设置 <code>okText</code> 与 <code>cancelText</code> 以自定义按钮文字</p>
</blockquote>
<demo-block>
        <p>设置<code>onOk</code> 与 <code>onCancel</code> 拿到按钮回调</p>

        <template #source><element-demo5 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; @click=&quot;open&quot;&gt;显示确认对话框&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$modal, $message} = instance.appContext.config.globalProperties

      const open = (type) =&gt; {
        $modal.confirm({
          title: '你确定删除吗',
          content: '删除之后，这个操作不可逆',
          cancelText: 'No',
          okText: 'Yes',
          onOk(){
            $message('点击了确定')
          },
          onCancel(){
            $message('点击了取消')
          }
        })
      }

      return {
        open
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_modal = _resolveComponent("x-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      onClick: $event => (_ctx.visible = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示对话框")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_modal, {
      title: "戏命师",
      modelValue: _ctx.visible,
      "onUpdate:modelValue": $event => ((_ctx.visible) = $event),
      onOk: _ctx.ok,
      onCancel: _ctx.cancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "我于杀戮之中绽放 ,亦如黎明中的花朵"),
        _createElementVNode("p", null, "你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue", "onOk", "onCancel"])
  ], 64))
}
  
    
        const {ref, getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const visible = ref(false)

      const ok = () => {
        $message.success('点击了确定')
      }

      const cancel = () => {
        $message('点击了取消')
      }
 
      return {
        visible,
        ok,
        cancel
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_icon = _resolveComponent("x-icon")
  const _component_x_modal = _resolveComponent("x-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: $event => (_ctx.visible1 = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("自定义页头页脚")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_modal, {
      modelValue: _ctx.visible1,
      "onUpdate:modelValue": $event => ((_ctx.visible1) = $event),
      style: {"width":"300px"}
    }, {
      head: _withCtx(() => [
        _createElementVNode("div", { style: {"text-align":"center"} }, [
          _createTextVNode(" 这个组件 "),
          _createVNode(_component_x_icon, { type: "x-icon-thumbs-up" })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_x_button, {
          type: "warning",
          block: "",
          onClick: $event => (_ctx.visible1 = false)
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, "我于杀戮之中绽放 ,亦如黎明中的花朵"),
        _createElementVNode("p", null, "你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: $event => (_ctx.visible2 = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("不带标题")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_modal, {
      modelValue: _ctx.visible2,
      "onUpdate:modelValue": $event => ((_ctx.visible2) = $event)
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "吾虽浪迹天涯，却未迷失本心"),
        _createElementVNode("p", null, "吾之初心，永世不忘"),
        _createElementVNode("p", null, "正义，好个冠冕堂皇之词")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"])
  ], 64))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const visible1 = ref(false)
      const visible2 = ref(false)

      return {
        visible1,
        visible2,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_modal = _resolveComponent("x-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: $event => (_ctx.visible = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示对话框")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_modal, {
      title: "戏命师",
      modelValue: _ctx.visible,
      "onUpdate:modelValue": $event => ((_ctx.visible) = $event),
      loading: _ctx.loading,
      onOk: _ctx.ok
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "我于杀戮之中绽放 ,亦如黎明中的花朵"),
        _createElementVNode("p", null, "你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue", "loading", "onOk"])
  ], 64))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const visible = ref(false)
      const loading = ref(false)

      const ok = () => {
        loading.value = true
        setTimeout(() => {
          loading.value = false
        }, 2000)
      }

      return {
        visible,
        loading,
        ok,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_modal = _resolveComponent("x-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      onClick: $event => (_ctx.visible1 = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("禁用右上角关闭 （含Esc键）")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_modal, {
      title: "戏命师",
      closable: false,
      modelValue: _ctx.visible1,
      "onUpdate:modelValue": $event => ((_ctx.visible1) = $event)
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "我于杀戮之中绽放 ,亦如黎明中的花朵"),
        _createElementVNode("p", null, "你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_button, {
      type: "primary",
      onClick: $event => (_ctx.visible2 = true)
    }, {
      default: _withCtx(() => [
        _createTextVNode("禁用遮罩层关闭")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_modal, {
      title: "戏命师",
      "mask-closable": false,
      modelValue: _ctx.visible2,
      "onUpdate:modelValue": $event => ((_ctx.visible2) = $event)
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "我于杀戮之中绽放 ,亦如黎明中的花朵"),
        _createElementVNode("p", null, "你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。")
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"])
  ], 64))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const visible1 = ref(false)
      const visible2 = ref(false)

      return {
        visible1,
        visible2,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "info",
      plain: "",
      onClick: $event => (_ctx.open('info'))
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示信息对话框")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "danger",
      plain: "",
      onClick: $event => (_ctx.open('error'))
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示错误对话框")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "success",
      plain: "",
      onClick: $event => (_ctx.open('success'))
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示成功对话框")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "warning",
      plain: "",
      onClick: $event => (_ctx.open('warning'))
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示警告对话框")
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$modal} = instance.appContext.config.globalProperties

      const open = (type) => {
        $modal[type]({
          title: '戏命师',
          content: '你，将饱含诗意。我的灵感正在涌现，作品即是一切，艺术值得为之痛苦，我为喝彩而生，你将为其呕心沥血。'
        })
      }

      return {
        open
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo5": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createBlock(_component_x_button, {
    type: "primary",
    onClick: _ctx.open
  }, {
    default: _withCtx(() => [
      _createTextVNode("显示确认对话框")
    ]),
    _: 1
  }, 8, ["onClick"]))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$modal, $message} = instance.appContext.config.globalProperties

      const open = (type) => {
        $modal.confirm({
          title: '你确定删除吗',
          content: '删除之后，这个操作不可逆',
          cancelText: 'No',
          okText: 'Yes',
          onOk(){
            $message('点击了确定')
          },
          onCancel(){
            $message('点击了取消')
          }
        })
      }

      return {
        open
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  